import { PayinOrderStatus } from '~/entities/payin';

export const areChecksEnabled = (status?: PayinOrderStatus) => {
    return (
        status === PayinOrderStatus.STATUS_MERCHANT_CONFIRMED ||
        status === PayinOrderStatus.STATUS_TRADER_CONFIRMED ||
        status === PayinOrderStatus.STATUS_WAITING_PROOFS_APPROVAL ||
        status === PayinOrderStatus.STATUS_ON_INVESTIGATION ||
        status === PayinOrderStatus.STATUS_ON_INVESTIGATION_APPROVE ||
        status === PayinOrderStatus.STATUS_ON_INVESTIGATION_DECLINED ||
        status === PayinOrderStatus.STATUS_PAYOUT_COMPLETED
    );
};
